/* ─────────────────────────────────────────────
   FEATURE SWITCHES

   For things that are built and ready but must not be public yet. Nothing
   here is a permanent decision - each flag exists so the work survives until
   the salon can actually deliver on it.
   ───────────────────────────────────────────── */

/**
 * Wigs are not in stock yet, so /perike is off the site entirely: no route,
 * no menu or footer entry, no sitemap URL, no prerendered page, and no link
 * from the extensions page.
 *
 * The page, its copy in all three languages and its schema are all still in
 * the repo. To bring it back when the stock arrives:
 *
 *   1. flip this to true
 *   2. add the three /perike URLs back to public/sitemap.xml
 *      (sr /perike, en /wigs, de /peruecken - the extensions block right
 *       above them is the template) and bump the count from 72 to 75
 *   3. put the wigs wording back into `hairdresserService.services`
 *      (`.extensionsTitle`, `.extensionsP`, `.extensionsLink`) in the three
 *      locale files - that copy currently mentions extensions and ponytails
 *      only - and add a second link on /hairdresser next to the extensions
 *      one, pointing at linkTo('/perike', lang)
 *
 * Everything else follows automatically.
 */
export const WIGS_ENABLED = false;
